import { Backend, getQueryParamValue, RawQuery } from '@shared/datastore/core';
import {
  ContextTypeApi,
  ThreadsGetResultApi,
} from 'api-typings/messages/messages_types';
import { Thread } from './threads.model';

declare module '../core/backend' {
  interface BackendApiFetchTypes {
    threads: ThreadsGetResultApi;
  }
}

export const threadsBackend: Backend<'threads'> = {
  fetch: (_, key2, query) => ({
    endpoint: `messages/0.1/threads`,
    params: {
      threads: getThreadIdsQueryParamValue(query),
      members: getThreadMembersQueryParamValue(query),
      context_type: getThreadContextTypeQueryParamValue(query),
      contexts: getThreadContextIdsQueryParamValue(query),
      thread_types: query ? getQueryParamValue(query, 'threadType') : [],
      unread_count: 'true',
      last_message: 'true',
      context_details: 'true',
      user_details: 'true',
      user_read_times: 'true',
    },
  }),
  post: () => ({
    endpoint: `messages/0.1/threads/`,
    params: {},
  }),
};

// TODO: move all these helper functions to somewhere more appropriate
function getThreadMembersQueryParamValue(
  query?: RawQuery<Thread>,
): ReadonlyArray<number> {
  return query &&
    query.params &&
    query.params.otherMembers &&
    query.params.otherMembers.condition === '=='
    ? query.params.otherMembers.value
    : [];
}

function getThreadIdsQueryParamValue(
  query?: RawQuery<Thread>,
): ReadonlyArray<number> {
  return query &&
    query.params &&
    query.params.id &&
    query.params.id.condition === '==' &&
    query.params.id.value
    ? [query.params.id.value]
    : [];
}

function getThreadContextTypeQueryParamValue(
  query?: RawQuery<Thread>,
): ContextTypeApi | undefined {
  return query &&
    query.params &&
    query.params.context &&
    query.params.context.condition === '==' &&
    query.params.context.value &&
    query.params.context.value.type
    ? query.params.context.value.type
    : undefined;
}

function getThreadContextIdsQueryParamValue(
  query?: RawQuery<Thread>,
): number[] {
  return query &&
    query.params &&
    query.params.context &&
    query.params.context.condition === '==' &&
    query.params.context.value &&
    query.params.context.value.type !== ContextTypeApi.NONE
    ? [query.params.context.value.id]
    : [];
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/threads/threads.backend.ts